import { ethers, JsonRpcSigner, BrowserProvider } from "ethers";

import detectEthereumProvider from '@metamask/detect-provider';
import CoinbaseWalletSDK from '@coinbase/wallet-sdk';
//import EthereumProvider from '@walletconnect/ethereum-provider';

const WALLETCONNECT_PROJECT_ID = '684a2fb7286137c89a9f2e1ee94f434c';
const DEFAULT_CHAIN_ID = 1;

import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { map, distinctUntilChanged } from 'rxjs/operators';
import { UserService } from "./user.service";
import { Web3SignInDto } from "../dtos/web3-sign-in.dto";
import { UserAuthDto } from "../dtos/user-auth.dto";
import { ApiService } from "./base/api.service";
import { isPlatformBrowser } from "@angular/common";
import EthereumProvider from "@walletconnect/ethereum-provider";
import { environment } from "../environments/environment";


var window: Window & {
    ethereum: any
    web3: any
} = globalThis as any;

const contractNetworks = [
    {
        chainId: '0xaa36a7',
        chainName: 'Sepolia Testnet',
        rpcUrl: 'https://sepolia.infura.io',
        currencySymbol: 'ETH'
    },
    {
        chainId: '0x13882',
        chainName: 'Polygon Amoy Testnet',
        rpcUrl: 'https://amoy.polygonscan.com',
        currencySymbol: 'POL'
    },
    {
        chainId: '0x89',
        chainName: 'Polygon Mainnet',
        rpcUrl: 'https://polygon-mainnet.infura.io',
        currencySymbol: 'POL'
    }
]

@Injectable({
    providedIn: 'root'
})
export class Web3WalletService {

    public providerRef: ethers.BrowserProvider | null = null;
    public providerType: 'metamask' | 'walletconnect' | 'coinbase' | 'sequence' | null = null;

    public onChangeUser: BehaviorSubject<UserAuthDto | null> = new BehaviorSubject<UserAuthDto | null>(null);

    // Stream of just the wallet address with distinct emission semantics for easier subscription
    public readonly walletAddress$ = this.onChangeUser.pipe(
        map(u => u?.walletAddress ? u.walletAddress.toLowerCase() : null),
        distinctUntilChanged()
    );

    private syncInProgress: boolean = false;

    private walletConnectProvider: any | null = null;
    constructor(
        @Inject(PLATFORM_ID) private platformId: Object,
        private readonly apiService: ApiService,
        private readonly userService: UserService
    ) {
        if (isPlatformBrowser(this.platformId)) {
            import('@walletconnect/ethereum-provider').then((module) => {
                this.walletConnectProvider = module.default;
            });

            if (window.ethereum) {
                window.ethereum.on('connect', async () => {
                    if (this.providerType)
                        await this.onSyncState(this.providerType);
                });

                window.ethereum.on('disconnect', async () => {
                    if (this.providerType)
                        await this.onSyncState(this.providerType);
                });

                window.ethereum.on('accountsChanged', async () => {
                    if (this.providerType)
                        await this.onSyncState(this.providerType);
                });
            }
        }

    }

    getWalletAddress(): string | null {
        return this.onChangeUser.value?.walletAddress?.toLowerCase() ?? null;
    }

    isWalletConnected(): boolean {
        return this.getWalletAddress() !== null;
    }

    async init(): Promise<void> {
        if (isPlatformBrowser(this.platformId)) {
            this.breedingContractABI = (await import('./../../public/assets/abis/nft-breeding-contract.json')).default;
            const providerType = localStorage.getItem('walletType');
            if (providerType) {
                if (providerType === 'metamask') {
                    const connectionRef = await this.connect(providerType);
                    await this.useSigner(connectionRef);
                } else if (providerType === 'coinbase') {
                    const connectionRef = await this.connect(providerType);
                    await this.useSigner(connectionRef);
                } else if (providerType === 'walletconnect') {
                    setTimeout(async () => {
                        const connectionRef = await this.connect(providerType);
                        await this.useSigner(connectionRef);
                    }, 1000);
                } else if (providerType === 'sequence') {
                    const connectionRef = await this.connect(providerType);
                    await this.useSigner(connectionRef);
                }
            }
        }
    }

    private walletConnectProviderRef: EthereumProvider | null = null;
    async connect(wallet: 'metamask' | 'coinbase' | 'walletconnect' | 'sequence'): Promise<{ provider: BrowserProvider, type: 'metamask' | 'walletconnect' | 'coinbase' | 'sequence' }> {
        if (wallet === 'metamask') {
            const provider: any = await detectEthereumProvider({ mustBeMetaMask: true });
            if (!provider || !provider.isMetaMask) {
                throw new Error('MetaMask not found or masked by Trust Wallet');
            }

            await provider.request({ method: 'eth_requestAccounts' });
            const browserProvider = new BrowserProvider(provider);
            return { provider: browserProvider, type: 'metamask' };
        }

        if (wallet === 'coinbase') {
            const coinbase = new CoinbaseWalletSDK({
                appName: 'BeastBborne'
            });
            const cbProvider = coinbase.makeWeb3Provider();
            await cbProvider.request({ method: 'eth_requestAccounts' });
            const browserProvider = new BrowserProvider(cbProvider);
            return { provider: browserProvider, type: 'coinbase' };
        }

        if (wallet === 'walletconnect') {
            if (!this.walletConnectProviderRef) {
                this.walletConnectProviderRef = await this.walletConnectProvider.init({
                    name: 'BeastBborneDev',
                    description: 'AppKit Example',
                    icons: ['https://assets.reown.com/reown-profile-pic.png'],
                    url: 'https://reown.com/appkit',
                    projectId: WALLETCONNECT_PROJECT_ID,
                    chains: [DEFAULT_CHAIN_ID],
                    showQrModal: true
                });
            }


            await this.walletConnectProviderRef!.enable();
            const browserProvider = new BrowserProvider(this.walletConnectProviderRef!);
            return { provider: browserProvider, type: 'walletconnect' };
        }

        if (wallet === 'sequence') {
            // const sequenceWallet = new SequenceWallet({

            // });
            // const wallet = await SequenceWallet.connect({
            //     projectAccessKey: SEQUENCE_PROJECT_KEY,
            //     network: 'mainnet'
            // });

            // const browserProvider = new BrowserProvider(wallet.getProvider());
            // const signer = await browserProvider.getSigner();
            // return signer;
            // const network = 'amoy' // change for the network you need
            // const projectAccessKey = 'AQAAAAAAAJbd_5JOcE50AqglZCtvu51YlGI'
            // const waasConfigKey = 'eyJwcm9qZWN0SWQiOjM4NjIxLCJycGNTZXJ2ZXIiOiJodHRwczovL3dhYXMuc2VxdWVuY2UuYXBwIn0='

            // const sequence = new SequenceWaaS({
            //     network,
            //     projectAccessKey,
            //     waasConfigKey,

            // })

            // if (await sequence.isSignedIn()){


            //     //const wallet = await sequence.pro;

            // } else {
            //     const session = await sequence.signIn({ guest: true }, "Session name"); 
            //     debugger
            // }
        }

        throw new Error('Unsupported wallet');
    }

    async useSigner(connectionRef: { provider: BrowserProvider, type: 'metamask' | 'walletconnect' | 'coinbase' | 'sequence' }): Promise<void> {
        this.providerRef = connectionRef.provider;
        this.providerType = connectionRef.type;

        await this.onSyncState(connectionRef.type);
    }

    public readonly adminAddress: string = environment.adminAddress;
    getAdminAddress(): string {
        return this.adminAddress;
    }

    async getSigner(): Promise<JsonRpcSigner> {
        const signer = await this.providerRef!.getSigner();
        return signer;
    }

    async getFeeData(): Promise<ethers.FeeData> {
        const feeData = await this.providerRef!.getFeeData();
        return feeData;
    }

    private readonly coinContractAddress: string = environment.coinContractAddress;
    private readonly coinContractNetwork: string = environment.coinContractNetwork;
    private readonly coinContractABI = [
        'function approve(address spender, uint256 value) returns (bool)',
        'function allowance(address owner, address spender) view returns (uint256)',
    ];
    async getCoinContract(): Promise<ethers.Contract> {
        await this.switchToNetwork(this.coinContractNetwork);
        const signer = await this.getSigner();
        const contract = new ethers.Contract(this.coinContractAddress, this.coinContractABI, signer);
        return contract;
    }

    private readonly nftContractAddress: string = environment.nftContractAddress;
    private readonly nftContractNetwork: string = environment.nftContractNetwork;
    private readonly nftContractABI = [
        'function approve(address spender, uint256 tokenId) returns (bool)',
        'function ownerOf(uint256 tokenId) view returns (address)',
        'function isApprovedForAll(address owner, address operator) view returns (bool)',
        'function setApprovalForAll(address operator, bool approved) returns (bool)',
    ];
    async getNftContract(): Promise<ethers.Contract> {
        await this.switchToNetwork(this.nftContractNetwork);
        const signer = await this.getSigner();
        const contract = new ethers.Contract(this.nftContractAddress, this.nftContractABI, signer);
        return contract;
    }

    private readonly breedingContractAddress: string = environment.nftBreedingContractAddress;
    private readonly breedingContractNetwork: string = environment.nftBreedingContractNetwork;
    private breedingContractABI: any = [];
    //     "function checkAbilityToBreed(uint256 tokenId) view returns (bool)",
    //     "function getNotFungibleTokenAddr() view returns (address)",
    //     "function getPaymentTokenAddr() view returns (address)",
    //     "function getBreedingFeeByRarities(uint8[] rarities) view returns (uint256)",
    //     "function createBreedingOrder(uint256 firstTokenId, uint256 secondTokenId) external returns (uint256 orderId)",
    //     "function createCreature (uint256 orderId) external returns (uint256 orderId)",
    //     "event BreedingOrderCreated(uint256 orderId, uint256 creature1Id, uint256 creature2Id, address owner)"

    // ];
    async getBreedingContract(): Promise<ethers.Contract> {
        await this.switchToNetwork(this.breedingContractNetwork);
        const signer = await this.getSigner();
        const contract = new ethers.Contract(this.breedingContractAddress, this.breedingContractABI, signer);
        return contract;
    }


    private async onSyncState(type: 'metamask' | 'walletconnect' | 'coinbase' | 'sequence'): Promise<void> {
        if (!this.providerRef) return;
        // Prevent overlapping syncs which can happen if multiple events fire rapidly
        if (this.syncInProgress) return;
        this.syncInProgress = true;
        try {
            const wallets = await this.providerRef.listAccounts();
            const isConnected = wallets.length > 0;
            if (!isConnected) {
                this.onChangeUser.next(null);
                localStorage.removeItem('walletType');
                localStorage.removeItem('walletAddress');
                localStorage.removeItem('user');
                return;
            }

            const self = this;
            const walletRaw = wallets[0].address;
            const wallet = walletRaw.toLowerCase();

            const storedType = localStorage.getItem('walletType');
            const storedWallet = localStorage.getItem('walletAddress')?.toLowerCase() || null;

            // If unchanged, just emit cached user (ensuring normalization)
            if (storedWallet === wallet && storedType === type) {
                const cached = localStorage.getItem('user');
                if (cached) {
                    try {
                        const user = JSON.parse(cached) as UserAuthDto;
                        if (user.walletAddress?.toLowerCase() !== wallet) {
                            user.walletAddress = wallet; // normalize
                            localStorage.setItem('user', JSON.stringify(user));
                        }
                        this.onChangeUser.next(user);
                    } catch (e) {
                        console.warn('Failed to parse cached user; clearing.', e);
                        this.onChangeUser.next(null);
                    }
                }
                return;
            }

            // Wallet changed or type changed: clear & re-auth
            localStorage.removeItem('walletType');
            localStorage.removeItem('walletAddress');
            localStorage.removeItem('user');
            this.onChangeUser.next(null);

            this.userService.requestWeb3SignIn({ walletId: wallet }).subscribe({
                next: async (nonceData) => {
                    try {
                        const signer = await self.providerRef!.getSigner();
                        const signature = await signer.signMessage(nonceData.nonce);
                        const signInData: Web3SignInDto = {
                            walletId: wallet,
                            signature: signature,
                            nonce: nonceData.nonce,
                            providerType: type,
                        };
                        self.userService.verifyWeb3SignIn(signInData).subscribe({
                            next: async (user) => {
                                user.walletAddress = wallet; // normalized
                                self.onChangeUser.next(user);
                                localStorage.setItem('walletType', type);
                                localStorage.setItem('walletAddress', wallet);
                                localStorage.setItem('user', JSON.stringify(user));
                            },
                            error: (err) => {
                                console.error('Failed to sign in:', err);
                            },
                        });
                    } catch (err) {
                        console.error('Error during wallet sign-in sequence:', err);
                    }
                },
                error: (err) => {
                    console.error('Failed to request web3 sign-in (nonce):', err);
                },
            });
        } finally {
            this.syncInProgress = false;
        }
    }

    private async switchToNetwork(name: string) {

        const network = contractNetworks.find((network) => network.chainName === name);
        if (!network) {
            throw new Error(`Network ${name} not found`);
        }
        const { chainId, chainName, rpcUrl, currencySymbol } = network;
        //chainId: string, chainName: string, rpcUrl: string, currencySymbol: string
        const currentChainId = await (window as any).ethereum.request({ method: 'eth_chainId' });

        if (currentChainId === chainId) {
            console.log(`Already connected to chain ${chainId}`);
            return;
        }

        try {
            await (window as any).ethereum.request({
                method: 'wallet_switchEthereumChain',
                params: [{ chainId }],
            });
        } catch (switchError: any) {
            if (switchError.code === 4902) {
                try {
                    await (window as any).ethereum.request({
                        method: 'wallet_addEthereumChain',
                        params: [
                            {
                                chainId,
                                chainName,
                                rpcUrls: [rpcUrl],
                                nativeCurrency: {
                                    name: chainName,
                                    symbol: currencySymbol,
                                    decimals: 18,
                                },
                            },
                        ],
                    });
                } catch (addError) {
                    console.error('Failed to add network:', addError);
                    throw addError;
                }
            } else {
                console.error('Failed to switch network:', switchError);
                throw switchError;
            }
        }
    }
}
